// "AdminReports.jsx"

import React from "react";
import styles from "./AdminReports.module.css"; // i tuoi stili admin
import CommonReportsPage from "@/commons/tickets/CommonReportsPage";
import { environment } from "@/commons/configs/Config";
import Cookies from "js-cookie";

import Background from "@/commons/pages/borders/background/Background";
import Header from "@/commons/pages/borders/header/Header";
import Footer from "@/commons/pages/borders/footer/Footer";

/** Funzione fetch per i report admin */
async function fetchAdminReports(filter, page, itemsPerPage) {
    const userToken = Cookies.get(environment.tokenName);
    const url = `${environment.apiUrlTwo}/posts/getAllUserFiltered?status=${filter}`;
    const pageData = { page, items: itemsPerPage };

    const resp = await fetch(url, {
        method: "POST",
        headers: {
            Authorization: userToken,
            "Content-Type": "application/json",
        },
        body: JSON.stringify(pageData),
    });
    if (resp.status === 200) {
        return await resp.json(); // {content: [...], totalElements: number}
    } else {
        return { content: [], totalElements: 0 };
    }
}

function AdminReports() {
    function handleReportClick(reportId, event) {
        event.preventDefault();
        window.location.href = environment.reportsUrl + "post/" + reportId;
    }

    return (
        <>
            <Background />
            <div className={styles.page__body}>
                <Header/>
                <div className={styles.page__content}>
                    <div className={styles.MainAdmin_ReportsMainBox}>
                        <CommonReportsPage
                            pageTitle="I Reports degli utenti"
                            fetchReports={fetchAdminReports}
                            onReportClick={handleReportClick}
                            newReportButtonUrl={null}
                        />
                    </div>
                </div>
                <Footer />
            </div>
        </>
    );
}

export default AdminReports;